import { CreateFighterTypeDto, FighterTypeDict } from "../../../../model/Dto/Dict/FighterType";
import { ApiRequest, RequestMethod } from "../../../request";

const URL = "/api/fighter-type";

export async function createFighterType(data: CreateFighterTypeDto): Promise<FighterTypeDict | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(URL);
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}
